import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import './AppStoreBanner.css';
import appIcon from '../Assets/Images/privateIQ_icon.png';

// Helper to check if banner should show (runs synchronously)
const shouldShowBanner = (pathname) => {
  const allowedPaths = ['/myiq', '/feestable', '/feed', '/courses', '/forums'];
  const isAllowedPage = allowedPaths.some(path => pathname.startsWith(path));
  const isIOS = localStorage.getItem('isIOSDevice') === 'true';
  const bannerDismissed = localStorage.getItem('appStoreBannerDismissed') === 'true';
  const isLoggedIn = !!localStorage.getItem('access_token');

  return isIOS && !bannerDismissed && isLoggedIn && isAllowedPage;
};

const AppStoreBanner = () => {
  const location = useLocation();
  const [showBanner, setShowBanner] = useState(() => shouldShowBanner(location.pathname));

  // Update on route change (but initial render is instant)
  const currentShouldShow = shouldShowBanner(location.pathname);
  if (currentShouldShow !== showBanner) {
    setShowBanner(currentShouldShow);
  }

  // Add/remove body class for CSS safe-area handling
  useEffect(() => {
    if (showBanner) {
      document.body.classList.add('app-banner-visible');
    } else {
      document.body.classList.remove('app-banner-visible');
    }
    return () => {
      document.body.classList.remove('app-banner-visible');
    };
  }, [showBanner]);

  const dismissBanner = () => {
    setShowBanner(false);
    localStorage.setItem('appStoreBannerDismissed', 'true');
  };

  const openAppStore = () => {
    window.location.href = 'https://apps.apple.com/us/app/privateiq/id6756243587';
  };

  if (!showBanner) return null;

  return (
    <div className="app-store-banner">
      <button className="banner-close" onClick={dismissBanner} aria-label="Close">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="18" height="18">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>

      <div className="banner-content">
        <img src={appIcon} alt="PrivateIQ App" className="banner-app-icon" />

        <div className="banner-text">
          <span className="banner-title">PrivateIQ</span>
          <span className="banner-subtitle">Open in the App Store</span>
        </div>
      </div>

      <button className="banner-open-btn" onClick={openAppStore}>
        OPEN
      </button>
    </div>
  );
};

export default AppStoreBanner;